import { render, staticRenderFns } from "./language-switch.vue?vue&type=template&id=2e850371&"
import script from "./language-switch.vue?vue&type=script&lang=ts&"
export * from "./language-switch.vue?vue&type=script&lang=ts&"
import style0 from "./language-switch.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "language-switch.vue"
export default component.exports